import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Central Sahel`}</h3>
    <p>{`Having barely recovered from the acute food crisis that hit the Sahel in 2018, many vulnerable families were affected by violence in 2019. More than 2.4 million people faced hunger in the Central Sahel, which encompasses Burkina Faso, Mali and Niger. WFP reached `}<a parentName="p" {...{
        "href": "https://reliefweb.int/sites/reliefweb.int/files/resources/WFP%20Central%20Sahel%20Situation%20Report%20%2820%20January%202020%29.pdf"
      }}>{`1.4 million`}</a>{` people across the region with life-saving food assistance thanks to support from donors like the EU.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      